"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.NoteFrame = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var NoteFrame = /** @class */ (function (_super) {
    __extends(NoteFrame, _super);
    function NoteFrame(props) {
        var _this = _super.call(this, props) || this;
        _this._iframeRef = (0, react_1.createRef)();
        return _this;
    }
    NoteFrame.prototype.componentDidMount = function () {
        this.updateIframeContent();
    };
    NoteFrame.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.iframeNote.id !== prevProps.iframeNote.id) {
            this.updateIframeContent();
        }
    };
    NoteFrame.prototype.updateIframeContent = function () {
        var iframeNote = this.props.iframeNote;
        var iframeDocument = this._iframeRef.current.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(iframeNote.content);
        iframeDocument.close();
        // necessary to prevent inner scrollbars on a note list
        iframeDocument.body.style.overflowY = 'hidden';
        var inputEls = iframeDocument.getElementsByTagName('input');
        for (var i = 0; i < inputEls.length; i++) {
            if (inputEls[i].type === 'checkbox') {
                inputEls[i].addEventListener('click', function (e) { return e.preventDefault(); });
            }
        }
    };
    NoteFrame.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("iframe", { className: "note-iframe autosize-iframe-content", sandbox: "allow-same-origin", ref: this._iframeRef }));
    };
    return NoteFrame;
}(react_1["default"].Component));
exports.NoteFrame = NoteFrame;
//# sourceMappingURL=note-frame.js.map